import { render, staticRenderFns } from "./ItemsMasterEdit.vue?vue&type=template&id=6455c9af&scoped=true&"
import script from "./ItemsMasterEdit.vue?vue&type=script&lang=js&"
export * from "./ItemsMasterEdit.vue?vue&type=script&lang=js&"
import style0 from "./ItemsMasterEdit.vue?vue&type=style&index=0&id=6455c9af&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6455c9af",
  null
  
)

export default component.exports